import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  variant?: 'red' | 'gold';
}
export function CTAButton({
  children,
  onClick,
  href,
  className = '',
  variant = 'red'
}: CTAButtonProps) {
  const baseStyle = 'inline-block rounded-full font-bold uppercase tracking-wide text-white transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-0.5 px-8 py-4 text-sm md:text-base';
  const variants = {
    red: 'bg-brand-red hover:bg-brand-redDark ring-4 ring-brand-redLight',
    gold: 'bg-brand-gold hover:bg-[#c2922b]'
  };
  const classes = `${baseStyle} ${variants[variant]} ${className}`;
  if (href) {
    return <a href={href} onClick={onClick} className={`${classes} text-center`} data-id="element-39">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={classes} data-id="element-40">
      {children}
    </button>;
}